import type { ObjectDirective } from 'vue'

export const tdClick: ObjectDirective = {
	mounted(el, binding) {
		const td = el.closest('td')
		if (!td) return

		td.style.cursor = 'pointer'

		const handler = (evt: Event) => {
			if (typeof binding.value === 'function') {
				binding.value(evt)
			}
		}

		;(el as any).__tdHandler__ = handler
		td.addEventListener('click', handler)
	},
	unmounted(el) {
		const td = el.closest('td')
		const handler = (el as any).__tdHandler__
		if (td && handler) td.removeEventListener('click', handler)
	}
}
